const GROUP_SLUGS = {
  'SAVINGS OPTIONS': 'savings',
  'TRADITIONAL OPTIONS': 'traditional',
  'EDGE OPTIONS': 'edge',
  'HOSPITAL OPTIONS': 'hospital',
  'BONCAP OPTIONS': 'boncap',
};

export const planGroups = [
  {
    label: 'SAVINGS OPTIONS',
    options: [
      { value: 'PL477', label: 'BonComprehensive' },
      { value: 'PL476', label: 'BonClassic' },
      { value: 'PL472', label: 'BonComplete' },
      { value: 'PL240', label: 'BonSave' },
      { value: 'PL475', label: 'BonFit' },
      { value: 'PL999', label: 'BonPrime' },
    ],
  },
  {
    label: 'TRADITIONAL OPTIONS',
    options: [
      { value: 'PL020', label: 'Standard' },
      { value: 'PL021', label: 'Standard Select' },
      { value: 'PL277', label: 'Primary' },
    ],
  },
  {
    label: 'EDGE OPTIONS',
    options: [
      { value: 'PL464', label: 'BonStart' },
      { value: 'PL465', label: 'BonStart Plus' },
    ],
  },
  {
    label: 'HOSPITAL OPTIONS',
    options: [
      { value: 'PL474', label: 'Hospital Standard' },
      { value: 'PL479', label: 'BonEssential' },
      { value: 'PL471', label: 'BonEssential Select' },
    ],
  },
  {
    label: 'BONCAP OPTIONS',
    options: [{ value: 'PL470', label: 'BonCap' }],
  },
];

export function getPlanMetadata(planCode) {
  if (!planCode) {
    return { selectedPlanGroup: '', selectedPlan: '' };
  }

  if (planCode === 'PL470') {
    return { selectedPlanGroup: 'boncap', selectedPlan: 'BonCap' };
  }

  for (const group of planGroups) {
    const match = group.options.find((option) => option.value === planCode);
    if (match) {
      return {
        selectedPlanGroup: GROUP_SLUGS[group.label] || group.label.toLowerCase(),
        selectedPlan: match.label,
      };
    }
  }

  return { selectedPlanGroup: '', selectedPlan: planCode };
}
